/**
 * SEYU custom product card hover logic.
 *
 * Behaviour:
 *  - mouseenter  → show image 2 immediately, start 2 s timer
 *  - mouseleave before 2 s → cancel timer, revert to image 1
 *  - after 2 s (regardless of cursor position) → lock on image 3
 *  - hover a DIFFERENT card → unlock all other locked cards (reset to image 1)
 */
(function () {
  'use strict';

  // Map from product-item element → pending timer id
  const timers = new WeakMap();

  function getProductItem(el) {
    return el.closest('[data-js-product-item]');
  }

  function getHolder(item) {
    return item.closest('.product-holder');
  }

  function showImage2(item) {
    item.classList.add('seyu-show-2');
  }

  function hideImage2(item) {
    item.classList.remove('seyu-show-2');
  }

  function lockImage3(item) {
    item.classList.remove('seyu-show-2');
    item.classList.add('seyu-locked');
  }

  function unlock(item) {
    item.classList.remove('seyu-locked', 'seyu-show-2');
    const t = timers.get(item);
    if (t) {
      clearTimeout(t);
      timers.delete(item);
    }
  }

  function unlockAllExcept(activeItem) {
    document.querySelectorAll('[data-js-product-item].seyu-locked').forEach(function (item) {
      if (item !== activeItem) {
        unlock(item);
      }
    });
  }

  // Use event delegation on the document so dynamically loaded cards are covered.
  document.addEventListener('mouseenter', function (e) {
    const item = getProductItem(e.target);
    if (!item) return;

    // Skip cards that have no secondary image (no hover behaviour needed)
    if (!item.classList.contains('with-secondary-image')) return;

    // Reset all OTHER locked cards back to image 1
    unlockAllExcept(item);

    // If this card is already locked, don't restart the sequence
    if (item.classList.contains('seyu-locked')) return;

    // Cancel any in-flight timer for this card (re-entering quickly)
    const existing = timers.get(item);
    if (existing) {
      clearTimeout(existing);
    }

    // Show image 2 immediately
    showImage2(item);

    // After 2 s → lock on image 3 (only if a third image exists)
    const hasThird = item.querySelector('.seyu-third-image');
    if (hasThird) {
      const t = setTimeout(function () {
        timers.delete(item);
        lockImage3(item);
      }, 1000);
      timers.set(item, t);
    }
  }, true /* capture: works on non-bubbling mouseenter */);

  document.addEventListener('mouseleave', function (e) {
    const item = getProductItem(e.target);
    if (!item) return;
    if (!item.classList.contains('with-secondary-image')) return;

    // If already locked, leave it locked
    if (item.classList.contains('seyu-locked')) return;

    // Cancel timer and revert to image 1
    const t = timers.get(item);
    if (t) {
      clearTimeout(t);
      timers.delete(item);
    }
    hideImage2(item);
  }, true);

})();
